import { render, staticRenderFns } from "./DeleteTeamFromStageTournament.vue?vue&type=template&id=2b367c12&scoped=true"
import script from "./DeleteTeamFromStageTournament.vue?vue&type=script&lang=js"
export * from "./DeleteTeamFromStageTournament.vue?vue&type=script&lang=js"
import style0 from "./DeleteTeamFromStageTournament.vue?vue&type=style&index=0&id=2b367c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b367c12",
  null
  
)

export default component.exports